import { Component, inject, viewChild } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BasicDialogComponent } from '../../../../shared/components/basic-dialog/basic-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [MatMenuModule, MatIconModule, MatToolbarModule, CommonModule, MatBadgeModule],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent {
  isCollapsed: boolean = false;
  notifications: boolean = false;
  activeHome: boolean = true;
  activeArchived: boolean = false;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { } 

    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    }

    notificationsActive() {
      this.notifications = !this.notifications;
    }

    navigate(route: string) {
      this.router.navigate([route]);
      this.updateActiveState(route);
    }

    updateActiveState(route: string) {
      this.activeHome = route === '/home';
      this.activeArchived = route === '/archived';
    }

    ngOnInit() {
      console.log(this.activeHome);
    }

    ngOnChange() {
      console.log(this.router.url);
    }
}
